import { nanoid } from 'nanoid'
import React from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { AddTagContent } from 'widgets/TemplateActions/ui/AddTagContent/AddTagContent.tsx'
import { type IActionTagProps } from 'widgets/TemplateActions/addTag'

export const removeTag = (props: IActionTagProps) => {
  const id = nanoid()
  modalStore.addModal({
    id,
    title: 'Remove tag',
    pureContent: true,
    ModalContent: () => <AddTagContent onClose={() => modalStore.closeModal(id)} {...props} />,
  })
}
